import { useNavigate } from "react-router-dom";
import { useEffect} from "react";
import seriesStore from "../stores/seriesStore.js";
import episodeStore from "../stores/episodeStore.js";
import { filterByStatus } from "../utils/filterByStatus.js";
import statusStore from "../stores/statusStore.js";

export default function RowCalendar({ selectedShow, activeHeader, setActiveHeader }) {
   const navigate = useNavigate();

    const serStore = seriesStore();
    const epStore = episodeStore();
    const staStore = statusStore();

    const { filteredSeries: startedSeries, filteredSeasons: startedSeasons } =
          filterByStatus(staStore.status, serStore.series, "Started");
    const { filteredSeries: comingSoonSeries, filteredSeasons: comingSoonSeasons } =
          filterByStatus(staStore.status, serStore.series, "Finished what's available");

    const allSeriesIds = [
      ...startedSeries?.map((s) => s._id) || [],
      ...comingSoonSeries?.map((s) => s._id) || [],
    ];

    useEffect(() => {
      epStore.fetchEpisode(); 
    }, [epStore.episode]);

    const today = new Date();
 
    const episodes =
      epStore.episode?.filter(
        (ep) =>
          allSeriesIds.includes(ep.seriesId) &&
          new Date(ep.releaseDate) >= today
      ).slice() // important: avoid mutating Zustand state
        .sort(
          (a, b) => new Date(a.releaseDate) - new Date(b.releaseDate)
        ) || [];

    const sortedEpisodes = [...episodes].sort((a, b) => {
      if (a.seriesId !== b.seriesId) return a.seriesId.localeCompare(b.seriesId);
      if (a.seasonNumber !== b.seasonNumber) return a.seasonNumber - b.seasonNumber;
      return a.episodeNumber - b.episodeNumber;
    });

    const combineEpisodes = (eps) => {
      const result = [];
      let current = null;

      // Sort by series, season, episode
      eps.sort((a, b) => {
        if (a.seriesId !== b.seriesId) return (seriesTitleById[a.seriesId] || "").localeCompare(seriesTitleById[b.seriesId] || "");
        if (a.seasonNumber !== b.seasonNumber) return a.seasonNumber - b.seasonNumber;
        return a.episodeNumber - b.episodeNumber;
      });

      eps.forEach(ep => { 
        if (
          current &&
          ep.seriesId === current.seriesId &&
          ep.seasonNumber === current.seasonNumber &&
          ep.episodeNumber === current.endEpisode + 1
        ) {
          current.endEpisode = ep.episodeNumber;
        } else {
          if (current) result.push(current);

          current = {
            ...ep,
            startEpisode: ep.episodeNumber,
            endEpisode: ep.episodeNumber
          };
        }
      });

      if (current) result.push(current);
      return result;
    }

    const formatDate = (date) =>
      new Date(date).toLocaleDateString("en-US", {
        weekday: "long",
        month: "short",
        day: "numeric",
    });

    const seriesTitleById = Object.fromEntries(
      serStore.series?.map((s) => [s._id, s.title]) || []
    );

    const seriesImgById = Object.fromEntries(
      serStore.series?.map((s) => [s._id, s.poster]) || []
    );

    if (!epStore.episode) {
      return <div className="rowCalendar"><p>Loading calendar…</p></div>;
    }

    today.setHours(0,0,0,0);

    const sevenDays = new Date();
    sevenDays.setDate(today.getDate() + 7);
    sevenDays.setHours(23,59,59,999);

    // Group upcoming episodes by series, merging consecutive episodes within each series
    const episodesBySeriesId = episodes.reduce((acc, ep) => {
    const release = new Date(ep.releaseDate);

    // Only future episodes
    if (release <= today) return acc;

    if (!acc[ep.seriesId]) acc[ep.seriesId] = [];

    const arr = acc[ep.seriesId];
    const last = arr[arr.length - 1];

    if (
      last &&
      last.seasonNumber === ep.seasonNumber &&
      ep.episodeNumber === last.endEpisode + 1
    ) {
      last.endEpisode = ep.episodeNumber;
    } else {
      arr.push({
        ...ep,
        startEpisode: ep.episodeNumber,
        endEpisode: ep.episodeNumber
      });
    }

    return acc;
  }, {});

  const seriesList = Object.entries(episodesBySeriesId)
  .map(([seriesId, episodeGroups]) => ({
    seriesId,
    title: seriesTitleById[seriesId] || "",
    poster: seriesImgById[seriesId],
    episodeGroups,
  }))
  .sort((a, b) => {
    const aDate = new Date(a.episodeGroups[0].releaseDate);
    const bDate = new Date(b.episodeGroups[0].releaseDate);
    return aDate - bDate;
  });

     return (
      <div className="rowCalendar">
        <h3 className="popularItemsHeader">Calendar</h3>
        <div className="series-list">

          {seriesList.map((s) => (
            <div  
            key={s.seriesId} 
            className="series-card">
                <img src={s.poster} alt={s.title} className="series-image" />
  
              {s.episodeGroups.map((g, i) => (
                <p key={i} className="calendarDay">
                  {new Date(g.releaseDate).toLocaleDateString("en-US", {
                      weekday: "short"
                    })}
                    <br></br>
                  S{g.seasonNumber} E{g.startEpisode}
                  {g.endEpisode !== g.startEpisode ? `-${g.endEpisode}` : ""}
                </p>
              ))}
            </div>
          ))}

      </div>
    </div>
  );
}
